export const initFooter = () => {
	const footer = document.querySelector( 'footer:not(.en)' );

	if ( !footer )
	{
		return;
	}

	const showInput = () => {
		footer.querySelector( 'li.personal-data' ).classList.add( 'show' );
		footer.querySelector( 'input[type="text"]' ).removeEventListener( 'focus', showInput );
	};

	footer.querySelector( 'input[type="text"]' )?.addEventListener( 'focus', showInput );
};
